{
    "CallsansweredwithinLabel": "Oproepen moeten worden beantwoord binnen:",
    "CallsansweredwithinPlaceholder": "10",
    "CallsansweredwithinUnit": "s",
    "ServiceLvlSettings_SectionHeader": "Serviceniveau-instellingen",
    "ServiceLvlSettings_SectionPara": "U kunt de volgende instellingen aanpassen om specifiek te bepalen hoe het huidige rapport de statistiek \"% serviceniveau\" berekent wanneer dit wordt ondersteund door de gekozen rapportstijl en ook is geselecteerd voor weergave.",
    "ServiceLvlSettings_IgnorequickabndcallswithinLabel": "Negeer snel afgebroken oproepen binnen:",
    "ServiceLvlSettings_IgnorequickabndcallswithinPlaceholder": "5",
    "ServiceLvlSettings_IgnorequickabndcallswithinEnabledHiddenlabel": "Is de instelling \"Snel afgebroken gesprekken binnen negeren\" ingeschakeld?",
    "ServiceLvlSettings_IgnorequickabndcallswithinUnit": "s",
    "ServiceLvlSettings_IgnoreovrflwdcallswithinLabel": "Negeer overvolle oproepen binnen:",
    "ServiceLvlSettings_IgnoreovrflwdcallswithinPlaceholder": "5",
    "ServiceLvlSettings_IgnoreovrflwdcallswithinEnabledHiddenlabel": "Is de instelling \"Negeer overgelopen oproepen binnen\" ingeschakeld?",
    "ServiceLvlSettings_IgnoreovrflwdcallswithinUnit": "s",
    "NAME": "ServiceLvlSettings"
}